import { render, staticRenderFns } from "./tutorTrain.vue?vue&type=template&id=2cb5b77a&scoped=true&"
import script from "./tutorTrain.vue?vue&type=script&lang=js&"
export * from "./tutorTrain.vue?vue&type=script&lang=js&"
import style0 from "./tutorTrain.vue?vue&type=style&index=0&id=2cb5b77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5b77a",
  null
  
)

export default component.exports